<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/17ksu7U/tc-custom/9781442468610.jpg?1730521893403" alt="This image is the cover for the book Fearless 2"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Fearless 2
      </h1>
      <p class="bookDescription body article font2">
        <b>No fear. No room to fail. Three adrenaline-racing thrill rides in a smart and sexy series, packaged in one bold book.</b><br/><br/>Gaia Moore is brilliant and beautiful. She’s trained in three kinds of martial arts, has a reflex speed that’s off the charts, and can break codes in four languages.<br/><br/>She’s also missing the fear gene.<br/><br/>Special attributes and fearlessness aside, Gaia simply wants a regular life, one with friends, and maybe even a boyfriend. And although the guy she really wants is still utterly unavailable, there are other options. Like the new dark and mysterious boy who is definitely interested. Gaia might be ready to take a walk on the wild side, but her love life is nothing compared to the danger that’s closing in.<br/><br/>Still on the search for information about her family, Gaia is finding out more and more each day…and one of her friends might be behind everything. Gaia must figure out who is about to betray her—and the wrong decision could be deadly.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Francine Pascal
      </h2>
      
      <p class="authorDescription body article">Francine Pascal is the creator of several bestselling series, including Fearless and Sweet Valley High, which was also made into a television series. She has written several novels, including <I>My First Love and Other Disasters</I>, <I>My Mother Was Never a Kid</I>, and <I>Love &amp; Betrayal &amp; Hold the Mayo</I>. She is also the author of <I>Sweet Valley Confidential: Ten Years Later</I>. She lives in New York and the South of France.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Simon Pulse
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?60677c90